// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2V4SX","productName":"Table_productName__3qBJh"};